import { CandidateDTO } from "../../../../models/recruiting/candidate/candidate-dto";
import { CandidateSTO } from "../../../../models/recruiting/candidate/candidate-sto";
import { BaseApiService } from "../../../base/base-api.service";

export class SuggestedCandidatesApiService extends BaseApiService<CandidateDTO, CandidateSTO> {
  constructor() {
    super({
      servicePath: "/Candidates",
      loadItemsPath: "/GetSuggestedCandidates",
    });
  }
}
